import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Fetcher from '../../common/util/Fetcher';
var fetcher = new Fetcher();
export var getQuizAnalysis = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(quizId) {
    var filter,
      url,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          filter = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'last_attempt';
          url = "/api/quizzes/".concat(quizId, "/analyses/quiz_analysis?filter=").concat(filter);
          _context.next = 4;
          return fetcher.get(url);
        case 4:
          return _context.abrupt("return", _context.sent);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getQuizAnalysis(_x) {
    return _ref.apply(this, arguments);
  };
}();